var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDoubleTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.5017 7.14253C15.8096 7.41962 15.8346 7.89384 15.5575 8.20172C15.2804 8.50961 14.8062 8.53456 14.4983 8.25747L12.75 6.68402V10.6C12.75 11.0142 12.4142 11.35 12 11.35C11.5858 11.35 11.25 11.0142 11.25 10.6V6.68402L9.50172 8.25747C9.19384 8.53456 8.71962 8.50961 8.44253 8.20172C8.16543 7.89384 8.19039 7.41962 8.49828 7.14253L11.4983 4.44253C11.7835 4.18582 12.2165 4.18582 12.5017 4.44253L15.5017 7.14253ZM11.4983 12.1425C11.7835 11.8858 12.2165 11.8858 12.5017 12.1425L15.5017 14.8425C15.8096 15.1196 15.8346 15.5938 15.5575 15.9017C15.2804 16.2096 14.8062 16.2346 14.4983 15.9575L12.75 14.384V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V14.384L9.50172 15.9575C9.19384 16.2346 8.71962 16.2096 8.44253 15.9017C8.16543 15.5938 8.19039 15.1196 8.49828 14.8425L11.4983 12.1425Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleTop);
export default __webpack_public_path__ + "static/media/arrow-double-top.d00bc6caff9ab1519a8ef7d336b8fe2f.svg";
export { ForwardRef as ReactComponent };